import { Link } from 'react-router-dom';
import { useSiteSettings } from '../../hooks/useSiteSettings';

export default function Footer() {
  const { settings: socialSettings } = useSiteSettings([
    'social_line',
    'social_facebook',
    'social_instagram',
    'social_tiktok',
    'social_youtube',
  ]);

  return (
    <footer className="bg-gradient-to-br from-emerald-800 to-emerald-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/1951b0480a7991f717d8723701e95243/c0ff92e5a82252bc47aa78b3b10aa452.png"
                  alt="MOFU Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
                MOFU 淨寵居
              </span>
            </div>
            <p className="text-white/80 text-sm mb-6">
              結合專業寵物空氣清淨技術與天然香氛藝術，為您和毛孩打造清新舒適的居家環境。
            </p>
            <div className="flex gap-3">
              <a
                href={socialSettings['social_line'] || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-coral-500 transition-colors cursor-pointer"
              >
                <i className="ri-line-fill text-lg"></i>
              </a>
              <a
                href={socialSettings['social_facebook'] || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-coral-500 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href={socialSettings['social_instagram'] || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-coral-500 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a
                href={socialSettings['social_tiktok'] || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-coral-500 transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-fill text-lg"></i>
              </a>
              <a
                href={socialSettings['social_youtube'] || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-coral-500 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">快速連結</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/80 hover:text-coral-400 transition-colors text-sm cursor-pointer whitespace-nowrap">首頁</Link></li>
              <li><Link to="/shop" className="text-white/80 hover:text-coral-400 transition-colors text-sm cursor-pointer whitespace-nowrap">線上商城</Link></li>
              <li><Link to="/workshop" className="text-white/80 hover:text-coral-400 transition-colors text-sm cursor-pointer whitespace-nowrap">香氛實驗室</Link></li>
              <li><Link to="/blog" className="text-white/80 hover:text-coral-400 transition-colors text-sm cursor-pointer whitespace-nowrap">部落格</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-coral-400 transition-colors text-sm cursor-pointer whitespace-nowrap">關於我們</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">聯絡資訊</h3>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-coral-400 mt-1"></i>
                <span>台灣新北市新莊區瓊林南路187巷29號</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-coral-400"></i>
                <span>02-2202-3192</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-coral-400"></i>
                <span>hello@mofu.com.tw</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-coral-400 mt-1"></i>
                <div>
                  <p>週一至週五 10:00-20:00</p>
                  <p>週六至週日 11:00-19:00</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-bold mb-4">訂閱電子報</h3>
            <p className="text-white/80 text-sm mb-4">獲取最新產品資訊與優惠</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="您的電子郵件"
                className="flex-1 px-4 py-2 bg-white/10 border border-white/20 rounded-full text-white placeholder-white/50 focus:outline-none focus:border-coral-400 transition-colors text-sm"
              />
              <button className="w-10 h-10 flex items-center justify-center bg-coral-500 rounded-full hover:bg-coral-600 transition-colors cursor-pointer">
                <i className="ri-send-plane-fill"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
          <p>&copy; 2024 MOFU 淨寵居. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-coral-400 transition-colors cursor-pointer whitespace-nowrap">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none opacity-5">
        <p className="text-[200px] font-bold whitespace-nowrap" style={{ fontFamily: "'Playfair Display', serif" }}>
          MOFU
        </p>
      </div>
    </footer>
  );
}
